import React, { useEffect, useRef, useState} from 'react';
import styles from "./ModalCustom.module.scss";

import { useStateWithCallbackLazy } from 'use-state-with-callback';


//functions
import { Step1Varification } from '../functions/varificationCode';
import { notify } from "../functions/toasts";



const ModalCustom = ({ mobile , onOffModal, setOnOffModal, codeVarifivation, setCodeVarifivation, modalVarificationButtonHandler , tokenPage }) => {

    const inputRef = useRef(null);


    const [numberTime, setNumberTime] = useStateWithCallbackLazy(65);
    const [checkResend, setcheckResend] = useState(false);

    useEffect(() => {

        inputRef.current.focus();

        if (onOffModal === "flex") {

            setNumberTime(65);
            setcheckResend(false);
            setCodeVarifivation("");


            const interval = setInterval(() => {
                setNumberTime(prevNumberTime => prevNumberTime - 1, (currentNumberTime) => {

                    if (currentNumberTime < 10) setNumberTime("0" + currentNumberTime)

                    if (currentNumberTime == 0) setcheckResend(true);

                    if (currentNumberTime === 0) clearInterval(interval)
                });

            }, 1000);



            return () => clearInterval(interval);
        }


    }, [onOffModal]);


    const codeHandler = (e) => {

        setCodeVarifivation(e.target.value);

    }


    const resendHandler = async () => {


        const stepOneVarification = await Step1Varification(mobile, tokenPage);

        if (stepOneVarification[0]) {

            notify(stepOneVarification[1], "success", 3000);

            setOnOffModal("none");

            setTimeout(() => {

                setOnOffModal("flex");

            }, 200);

        }
        else {

            notify(stepOneVarification[1], "error", 3000);
        }



    }



    return (

        <div className={styles.divpedar} style={{ display: onOffModal }}>

            <div className={styles.divBache}>


                <div className={styles.headerModal}></div>



                <div className={styles.bodyModal}>

                    <span className={styles.text1}>کد تایید</span>
                    <input type="text" className='my-2' placeholder='- - - - - -' maxLength={6} ref={inputRef} value={codeVarifivation} onChange={codeHandler} />

                    <div className={styles.conBtn}>
                        <span className={`${styles.text2} mt-1`}>00:{numberTime}</span>
                        <button className={`${styles.btnSend} btn btn-${checkResend ? "warning" : "success"} mt-2`} onClick={checkResend ? resendHandler : modalVarificationButtonHandler}>{checkResend ? "ارسال مجدد" : "تایید"}</button>
                    </div>

                   

                </div>


                <div className={styles.footerModal}>


                    <button className={`${styles.btns} btn btn-secondary`} onClick={() => setOnOffModal("none")}>بستن</button>


                </div>



            </div>



        </div>
    );
};

export default ModalCustom;